import {AppRouterInstance, NavigateOptions} from "next/dist/shared/lib/app-router-context.shared-runtime";

export default class RouterMgr {
    private static router:AppRouterInstance;

    static Init(router: AppRouterInstance){
        this.router = router;
    }

    static push(href: string, options?: NavigateOptions){
        this.router.push(href,options);
    }

    static back(){
        this.router.back();
    }

    static home(){
        this.router.push('/');
    }

    static shop(){
        this.router.push('/store');
    }

    static login(){
        this.router.push('/login');
    }

    static refresh(){
        this.router.refresh();
    }

}